<div class="lob-model-view" style="min-height: 10rem;">
  <div class="uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12 ">
    <div class=" uhc-font">
      <!-- Search Input -->
      <div class="d-flex justify-content-between search-buttons">
        <div class="table-search d-flex align-items-center col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
          <mat-form-field
            style="width: 100% !important;"
            class="inline-form-edit chip-select-stakeholder select-user-dropdown"
            floatLabel="never"
          >
            <mat-chip-grid #chipList>
              @if (selectedUsers && selectedUsers.displayName) {
              <mat-chip-row class="stk-mat-chip" (removed)="remove()">
                {{ selectedUsers.displayName }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              #msidInput
              [placeholder]="selectedUsers?.displayName ? '' : 'Search by Name/Mail'"
              [matAutocomplete]="auto"
              (keyup)="keyUpSearch($event)"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
            <mat-autocomplete
              showPanel="true"
              class="lob-options-list"
              #auto="matAutocomplete"
              (optionSelected)="selected($event)"
            >
              @for (user of users; track user) {
              <mat-option
                [disabled]="checkexist(user)"
                title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})"
                [value]="user"
              >
                {{ user.MSId || user.msid }}<{{ user.displayName }}>({{ user.mail }})
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        @if (dataSourceDetails && dataSourceDetails.data.length) {
        <div class="d-flex align-items-center justify-content-end user-buttons">
          <div>
            <button
              mat-raised-button
              class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
              (click)="deleteSelectedRoles()"
              [disabled]="!selectedRecords.length"
            >
              Delete
            </button>
          </div>
          <div class="table-header-icons table-header-icons-buttons">
            <ng-container>
              <button
                (click)="expandAllFunc()"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
              >
                {{ allRowsExpanded ? 'Collapse All' : 'Expand All' }}
              </button>
            </ng-container>
          </div>
        </div>
        }
      </div>

      <!-- Empty State Message -->
      @if (!searched) {
      <div style="padding: 2rem; text-align: center; color: #666;">
        <p class="general-txt">Please enter user details to view access information.</p>
      </div>
      } @if (searched) {
      <!-- Table Content -->
      <div class="uitk-c-card__content table-scroll-wrapper" style="margin-top: 0px !important;">
        <div class="stk-table-container">
          <!-- Maintenance Table -->
          @if (!showLoader && dataSourceDetails && dataSourceDetails.data.length > 0) {
          <app-maintenance-table-v4
            [TABLE_CONFIG]="TABLE_CONFIG"
            [COLUMNS]="TABLE_COLUMNS"
            [expanded_columns]="expanded_columns"
            [SORT_CONFIG]="sortConfig"
            [dataSource]="dataSourceDetails"
            [SCHEMA]="DATA_SCHEMA"
            (checkBoxEvent)="checkBoxEvent($event)"
            [pageSize]="TABLE_CONFIG.pageSize"
            [pageIndex]="TABLE_CONFIG.pageIndex"
            [expandAll]="expandAll"
            (collapseAll)="collapseAllFunc($event)"
            (addEvent)="onAddRow($event)"
            [isAddDisabledFn]="isAddDisabledForRow"
          >
          </app-maintenance-table-v4>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>

<app-modal [maximizable]="false" [inViewport]="true" #addPopup class="modal-demo" (closeModal)="closeAddPopup()">
  <ng-container class="app-modal-header">Add User Access</ng-container>
  <ng-container class="app-modal-body">
    <app-user-accesss-add-popup
      [rowData]="selectedRowForAdd"
      [msId]="msId"
      [mail]="mail"
      (closed)="closeAddPopup()"
      (submitted)="checkUserAccessForAllFeatures()"
    ></app-user-accesss-add-popup>
  </ng-container>
</app-modal>
